import axios from "axios";

export const setAxiosHeader = (clientToken: string, shopId: string) => {
  axios.defaults.headers.common["ClientToken"] = clientToken;
  axios.defaults.headers.common["ShopId"] = shopId;
  axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;
};
